<script lang="ts">
  import CamasView from './components/CamasView.svelte';
  import IngresosView from './components/IngresosView.svelte';
  import CuentasView from './components/CuentasView.svelte';
  import CobrosSecretariaView from './components/CobrosSecretariaView.svelte';
  import PacientesView from './components/PacientesView.svelte';
  import QuirofanoView from './components/QuirofanoView.svelte';
  import FarmaciaView from './components/FarmaciaView.svelte';
  import LaboratorioView from './components/LaboratorioView.svelte';
  import ImagenologiaView from './components/ImagenologiaView.svelte';
  import SignosView from './components/SignosView.svelte';
  import EpisodiosView from './components/EpisodiosView.svelte';
  import BodegaView from './components/BodegaView.svelte';
  import TesoreriaView from './components/TesoreriaView.svelte';
  import NominaView from './components/NominaView.svelte';
  import ContabilidadView from './components/ContabilidadView.svelte';
  import ReportesMspasView from './components/ReportesMspasView.svelte';
  import SemaforoView from './components/SemaforoView.svelte';
  import KardexView from './components/KardexView.svelte';
  import AltasView from './components/AltasView.svelte';
  import TriajeView from './components/TriajeView.svelte';
  import AseguradorasView from './components/AseguradorasView.svelte';
  import ConsultoriosView from './components/ConsultoriosView.svelte';
  import ProfesionalesView from './components/ProfesionalesView.svelte';
  import CompartidoView from './components/CompartidoView.svelte';
  import VeterinariaView from './components/VeterinariaView.svelte';
  import OpticaView from './components/OpticaView.svelte';
  import AgendaView from './components/AgendaView.svelte';
  import AgendaCentralView from './components/AgendaCentralView.svelte';
  import FarmaciaClinicaView from './components/FarmaciaClinicaView.svelte';
  import ExpedienteClinicoView from './components/ExpedienteClinicoView.svelte';
  import ExpedienteVeterinarioView from './components/ExpedienteVeterinarioView.svelte';
  import UsuariosView from './components/UsuariosView.svelte';
  import ConfiguracionView from './components/ConfiguracionView.svelte';
  import BitacoraView from './components/BitacoraView.svelte';
  import RoleDashboard from './components/dashboard/RoleDashboard.svelte';
  import type { Tab } from './lib/navigation';
  import { isClinicOrgTipo } from './lib/navigation';
  import { effectiveOrgTipo } from './lib/org-context.svelte';
  import { tenantCtx } from './lib/tenant.svelte';

  let {
    tab,
    onNavigate,
  }: {
    tab: Tab;
    onNavigate: (mod: string) => void;
  } = $props();

  const effectiveOrg = $derived(
    effectiveOrgTipo(tenantCtx.orgTipo as import('./lib/navigation').OrgTipo | null, tenantCtx.isHospitalEdition),
  );

  const useCobrosSecretaria = $derived(
    tenantCtx.isClinicEdition || isClinicOrgTipo(effectiveOrg),
  );
</script>

<div class:content-panel={tab !== 'dashboard'}>
  {#if tab === 'dashboard'}
    <RoleDashboard {onNavigate} />
  {:else if tab === 'pacientes'}
    <PacientesView />
  {:else if tab === 'camas'}
    <CamasView />
  {:else if tab === 'ingresos'}
    <IngresosView />
  {:else if tab === 'notas' || tab === 'expediente'}
    <ExpedienteClinicoView />
  {:else if tab === 'cuentas'}
    {#if useCobrosSecretaria}
      <CobrosSecretariaView />
    {:else}
      <CuentasView />
    {/if}
  {:else if tab === 'quirofano'}
    <QuirofanoView />
  {:else if tab === 'farmacia'}
    <FarmaciaView />
  {:else if tab === 'farmaciaPos'}
    <FarmaciaClinicaView />
  {:else if tab === 'laboratorio'}
    <LaboratorioView />
  {:else if tab === 'imagenologia'}
    <ImagenologiaView />
  {:else if tab === 'signos'}
    <SignosView orgTipo={effectiveOrg} />
  {:else if tab === 'episodios'}
    <EpisodiosView />
  {:else if tab === 'semaforo'}
    <SemaforoView />
  {:else if tab === 'kardex'}
    <KardexView />
  {:else if tab === 'altas'}
    <AltasView />
  {:else if tab === 'triaje'}
    <TriajeView />
  {:else if tab === 'bodega'}
    <BodegaView />
  {:else if tab === 'tesoreria'}
    <TesoreriaView />
  {:else if tab === 'nomina'}
    <NominaView />
  {:else if tab === 'contabilidad'}
    <ContabilidadView />
  {:else if tab === 'aseguradoras'}
    <AseguradorasView />
  {:else if tab === 'consultorios'}
    <ConsultoriosView />
  {:else if tab === 'profesionales'}
    <ProfesionalesView />
  {:else if tab === 'compartido'}
    <CompartidoView />
  {:else if tab === 'usuarios'}
    <UsuariosView />
  {:else if tab === 'configuracion'}
    <ConfiguracionView />
  {:else if tab === 'bitacora'}
    <BitacoraView />
  {:else if tab === 'agenda'}
    <AgendaView />
  {:else if tab === 'agendaCentral'}
    <AgendaCentralView />
  {:else if tab === 'expedienteVet'}
    <ExpedienteVeterinarioView />
  {:else if tab === 'veterinaria'}
    <VeterinariaView initialSub="mascotas" showSubNav={false} title="Mascotas y dueños" />
  {:else if tab === 'vetInternamiento'}
    <VeterinariaView initialSub="internamiento" showSubNav={false} title="Internamiento" />
  {:else if tab === 'vetMostrador'}
    <VeterinariaView initialSub="mostrador" showSubNav={false} catalogFilter="ALIMENTO" title="Alimentos y accesorios" />
  {:else if tab === 'vetFarmacia'}
    <VeterinariaView initialSub="mostrador" showSubNav={false} catalogFilter="MEDICAMENTO" title="Farmacia veterinaria" />
  {:else if tab === 'optica'}
    <OpticaView initialSub="pacientes" showSubNav={false} title="Pacientes y examen" />
  {:else if tab === 'opticaOrdenes'}
    <OpticaView initialSub="ordenes" showSubNav={false} title="Órdenes de taller" />
  {:else if tab === 'opticaInventario'}
    <OpticaView initialSub="inventario" showSubNav={false} title="Inventario óptica" />
  {:else if tab === 'reportes'}
    <ReportesMspasView />
  {/if}
</div>
